export default __webpack_public_path__ + "static/media/Team-800X500.d60038a5.png";